
<template>
  <div class="containerPage">
    <div class="headerCom" style="margin-bottom:0">
      <publicBreadCrumb :breadList="routerName!='consultRoom'?breadList:consultBreadList" />
      <Tabs v-show="!detailFlag && routerName!='consultRoom'" @headerTabs="headerTabsHandel"
        :tabsDataList="tabsDataList"></Tabs>
    </div>
    <section v-loading='loadMessageIng' element-loading-text="玩命加载中..." element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.7)"
      :style="`height: ${detailFlag ? 'calc(100% - 60px);' : 'calc(100% - 100px)'}`">
      <div class="section">
        <div class="chat-list" v-show="!detailFlag">
          <!-- 搜索+更多筛选 -->
          <div class="chat-search">
            <el-input :placeholder="routerName=='consultRoom'?'请搜索患者姓名':'请搜索患者姓名、线下机构'" size="medium"
              prefix-icon="el-icon-search" v-model="formDataValue.keyword" clearable maxlength="28"
              @change="patientListChange" @clear='clearInput'>
            </el-input>
            <el-popover popper-class="search-popover" placement="right" v-model="showPopver" width="520"
              trigger="click">
              <div class="more-search" slot="reference" :class="showPopver?'showPopver':''"> 更多筛选 </div>
              <el-form size="small" class="search-form" label-suffix=":" label-width="70px">
                <p class="title">更多筛选</p>
                <el-form-item label="渠道">
                  <el-select class="search-input" multiple maxlength="20" v-model="seachForm.channels" placeholder="请选择渠道"
                    filterable remote reserve-keyword v-selectLoadmore="loadmoreChannel" :remote-method="remoteChannel"
                    :loading="codeLoading" @visible-change='closeChannel' clearable>
                    <el-option v-for="(item,index) in channelList" :key="index" :label="item.channelName"
                      :value="item.followChannelId">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="患者标签">
                  <el-select class="search-input" multiple  maxlength="20" v-model="seachForm.labelIds" placeholder="请选择患者标签"
                    filterable remote reserve-keyword v-selectLoadmore="loadmorePatientTag" :remote-method="remotePatientTag"
                    :loading="codeLoading" @visible-change='closePatientTag' clearable>
                    <el-option v-for="(item,index) in patientTagList" :key="index" :label="item.labelName"
                      :value="item.labelId">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="合作机构">
                  <el-select class="search-input"  maxlength="20" v-model="seachForm.orgCode" placeholder="请选择合作机构"
                    filterable remote reserve-keyword v-selectLoadmore="loadmoreCooperateOrg" :remote-method="remoteCooperateOrg"
                    :loading="codeLoading" @visible-change='closeCooperateOrg' clearable>
                    <el-option v-for="(item,index) in cooperateOrgList" :key="index" :label="item.orgName"
                      :value="item.orgCode">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="关注病种">
                  <el-select class="search-input" maxlength="20" v-model="seachForm.followDiseaseId" placeholder="请选择病种"
                    filterable remote reserve-keyword v-selectLoadmore="loadmoreDisease" :remote-method="remoteDisease"
                    :loading="codeLoading" @visible-change='closeDisease' clearable>
                    <el-option v-for="(item,index) in diseaseList" :key="index" :label="item.diseaseTypeName"
                      :value="item.diseaseTypeId">
                    </el-option>
                  </el-select>
                </el-form-item>
                <template v-if="routerName!='consultRoom'">
                  <el-form-item label="机构">
                    <el-select class="search-input" maxlength="20" v-model="seachForm.hospitalId" placeholder="请选择机构"
                      filterable remote reserve-keyword v-selectLoadmore="loadmoreHospital"
                      :remote-method="remoteHospital" :loading="codeLoading" @visible-change='closeHospital' clearable>
                      <el-option v-for="(item,index) in hospitalList" :key="index" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="服务类型">
                    <el-select class="search-input" maxlength="20" v-model="seachForm.serviceType" placeholder="请选择服务类型"
                      clearable>
                      <el-option v-for="(item,index) in serviceTypeList" :key="index" :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="服务团队">
                    <el-select class="search-input" maxlength="20" v-model="seachForm.doctorTeamId"
                      placeholder="请选择服务团队" filterable remote reserve-keyword v-selectLoadmore="loadmoreServiceTeam"
                      :remote-method="remoteServiceTeam" :loading="codeLoading" @visible-change='closeServiceTeam'
                      clearable>
                      <el-option v-for="(item,index) in serviceTeamList" :key="index" :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="服务">
                    <el-select class="search-input" maxlength="20" v-model="seachForm.serviceId" placeholder="请选择服务"
                      filterable remote reserve-keyword v-selectLoadmore="loadmoreService"
                      :remote-method="remoteService" :loading="codeLoading" @visible-change='closeService' clearable>
                      <el-option v-for="(item,index) in searchServiceList" :key="index" :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="服务来源">
                    <el-select class="search-input" maxlength="20" v-model="seachForm.source" placeholder="请选择服务来源"
                      filterable remote reserve-keyword :remote-method="remoteServiceSource" :loading="codeLoading"
                      @visible-change='closeServiceSource' clearable>
                      <el-option v-for="(item,index) in serviceSourceList" :key="index" :label="item" :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </template>
                <el-form-item label="患者姓名">
                  <el-input class="search-input" maxlength="20" v-model="seachForm.patientName" placeholder="请输入患者姓名"
                    clearable autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="患者状态">
                  <el-select class="search-input" v-model="seachForm.logOff" placeholder="请选择患者状态" clearable>
                    <el-option v-for="(item,index) in patientStatus" :key="index" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class='search-btn'>
                  <el-button @click="patientListChange('reset')">重置</el-button>
                  <el-button type="primary" @click="patientListChange()">搜索</el-button>
                </el-form-item>
              </el-form>
            </el-popover>
          </div>
          <!-- 聊天列表 -->
          <ChatUserList ref="chatList" @propsUserItem="propsUserItemHandel" @propsUserPageChange="propsUserPageChange" @topUpClick="topUpClick"
            :userDataList="userDataListCopy" :currentPage="formDataValue" :patientTotal='patientTotal'
            :routerName="routerName" :currentSize="formDataValue.size">
          </ChatUserList>
        </div>
        <!-- 聊天窗口 -->
        <div class="right-box">
          <div class="change-team" v-if="routerName!='consultRoom'&&!detailFlag">
            <el-select v-model="serviceIMID" value-key="keyImId" placeholder="请选择" size="medium"
              @change="changeService" @visible-change="visibleChange">
              <el-option v-for="item in serviceList" :key="item.keyImId" :label="item.labelTime" :value="item"
                class="rewrite-option">
                <span class="label-left">{{item.labelTime}}</span>
                <span v-if="item.unReadNumber"
                  class="label-right">{{ item.unReadNumber > 99 ? '99+' : item.unReadNumber }}</span>
              </el-option>
            </el-select>
            <div class="patient-tags" @click="patientTagClcik" v-if="isConsult !== 'true'">
              <span class="tab-icon"></span>
              <span>患者标签</span>
            </div>
          </div>
          <div class="chat-content" v-if="userDataListCopy && userDataListCopy.length > 0">
            <!-- 重新创建元素将带返回按钮的头覆盖(absulote)到IM组件的完整头部，width: 100% height: 40px -->
            <div class="detail-tab-title" v-if="detailFlag">
              <span @click="backToChatlist"><i class="el-icon-arrow-left"></i>返回</span>
              <div class="current-patient">{{ IMInfo.patientName }}</div>
              <div class="team-doctor" v-if="routerName!='consultRoom'">
                <el-select v-model="serviceIMID" value-key="keyImId" placeholder="请选择" size="mini"
                  @change="changeService" @visible-change="visibleChange">
                  <el-option v-for="item in serviceList" :key="item.keyImId" :label="item.labelTime" :value="item"
                    class="rewrite-option">
                    <span class="label-left">{{item.labelTime}}</span>
                    <span v-if="item.unReadNumber"
                      class="label-right">{{ item.unReadNumber > 99 ? '99+' : item.unReadNumber }}</span>
                  </el-option>
                </el-select>
              </div>
            </div>
            <IM :IMInfo="IMInfo" ref="IM" @getRightData="getRightData" :topHeight="40" :pageType="this.IMInfo.pageType"
              :routerName="routerName"   :tabClickName='tabClickName' :synergyId='synergyId' :style="`height: ${detailFlag ? 'calc(100% - 40px)' : '100%'}`">
            </IM>
            <!-- 右侧数据头 -->
            <div class="right-tab" v-show="!detailFlag">
              <span class="right-tab-span" v-for="(item, key) in rightTitleList" :key="key"
                @click="rightTitleClick(item.val,key)">
                <el-badge :hidden="!rightTitleBadge[key]" :value="rightTitleBadge[key]" :max="99" class="item">
                  {{ item.label}}
                </el-badge>
                <span v-if="item.val == 9 && patientSymptomData.length > 0" class="red-tag"></span>
              </span>
            </div>
          </div>
          <div class="empty" v-else>
            <img src="../../../treatment/static/empty.png" />
          </div>
        </div>
        <!--  患者列表隐藏时 显示右侧基本信息等等  -->
        <div class="chat-right-content" v-show="detailFlag">
          <RightContent ref="rightContent" :routerName="routerName" :logOff="logOff" :rightInfo="rightData"
            :patientId="newPatiend" />
        </div>
      </div>
    </section>
    <!-- 患者标签-抽屉式弹框 -->
    <el-drawer class="patient-tags" title="标签" :visible.sync="patientTagVisible" :before-close="updatePatientTagVisible">
      <PatientTags :patientLabelObj="patientLabelObj" @upPatientTag="upPatientTag" />
    </el-drawer>
    <!-- <PatientTags :visible="patientTagVisible" @updatePatientTagVisible="updatePatientTagVisible" /> -->
  </div>
</template>

<script>
import IM from "../../components/IM/IM.vue";
import NavTab from "../../components/NavTap";
import Tabs from "../../components/Tabs";
import ChatUserList from "../../components/ChatUserList";
import {
  apiGetWholeCourse,
  getServeNameByPatientId,
  updatePatientGroup,
  getPatientWholeCourseId,
  deleteRecordByGroupCode,
  followingChannel,
  followingTag,
  followingCooperateOrg,
  followingDisease,
  followingTeam,
  followingService,
  followingSource,
  getListPatientLabelByStatus
} from "../../api";
import { PublicNewMsg } from "@/store/socketsMessage";
import ImList from "../../common";
import { getPatientDetailedInformationVO } from "@/views/newPatientmanage/api/index.js";
import { getHospital } from "@/views/CustomerService/api/index.js";
import local from "@/utils/local.js";
export default {
  name: "Case1",
  mixins: [ImList],
  props: {
    routerName: {
      type: String,
      default: "Case1Page"
    }
  },
  data() {
    return {
      isConsult: local.get("isConsult"),
      synergyId:'',
      tabClickName:'',
      breadList: [{ name: "疗程管理" }, { name: "入案管理" }],
      consultBreadList: [{ name: "客服管理" }, { name: "客服咨询" }],
      patientSymptomData: [],
      loadMessageIng: false,
      showPopver: false,
      codeLoading: false,
      seachForm: {
        channels: [],
        labelIds:[],
        orgCode:'',
        followDiseaseId: "",
        hospitalId: "",
        serviceType: "",
        logOff: "",
        doctorTeamId: "",
        source: "",
        serviceId: "",
        patientName: ""
      },
      hospitalList: [],
      channelList: [],
      diseaseList: [],
      patientTagList:[],
      cooperateOrgList:[],
      serviceTypeList: [
        { name: "权益", id: 2 },
        { name: "付费", id: 1 }
      ],
      patientStatus: [
        { label: "正常", value: false },
        { label: "已注销", value: true }
      ],
      serviceTeamList: [],
      serviceSourceList: [],
      searchServiceList: [],
      checkedWholeCourseId: "",
      wholeCourseIdList: {},
      patientTotal: 0,
      formDataValue: {
        keyword: "", //模糊查询字段
        status: "", //1未申请 2已跟进 3评估中 4待医生确认 5已入案 6医生驳回 7待开始 8已中止 9待病人确认 10病人驳回 11医生取消
        current: 1,
        size: 100 //患者分页
      },
      hospitalSearch: {
        current: 1,
        size: 10,
        totalpages: "",
        name: ""
      },
      channelSearch: {
        current: 1,
        size: 10,
        totalpages: "",
        channelName: ""
      },
      patientTagSearch: {
        current: 1,
        size: 10,
        totalpages: "",
        labelName: ""
      },
      cooperateOrgSearch: {
        current: 1,
        size: 10,
        totalpages: "",
        orgName: ""
      },
      diseaseSearch: {
        current: 1,
        totalpages: "",
        size: 10,
        diseaseTypeName: ""
      },
      serviceTeamSearch: {
        current: 1,
        totalpages: "",
        name: ""
      },
      serviceSourceSearch: {
        name: ""
      },
      serviceSearch: {
        current: 1,
        size: 10,
        totalpages:'',
        name: ""
      },
      tabsDataList: [
        {
          name: "全部",
          id: "",
          numberNumber: "",
          number: "",
          title: "",
          titleName: ""
        },
        {
          name: "未购买",
          id: "1",
          numberNumber: "",
          number: "",
          title: "notApply",
          titleName: "notApplyAdapt"
        },
        {
          name: "评估中",
          id: "3",
          numberNumber: "",
          number: "",
          title: "assess",
          titleName: "assessAdapt"
        },
        {
          name: "进行中",
          id: "5",
          numberNumber: "",
          number: "",
          title: "doctorAffirm",
          titleName: "doctorAffirmAdapt"
        },
        {
          name: "未开始",
          id: "7",
          numberNumber: "",
          number: "",
          title: "toStart",
          titleName: "toStartAdapt"
        },
        {
          name: "服务结束",
          id: "12",
          numberNumber: "",
          number: "",
          title: "serviceEnd",
          titleName: "serviceEndAdapt"
        }
      ],
      rightTitleList: [
        {
          label: "个人信息",
          val: 1
        },
        {
          label: "入案详情",
          val: 2
        },
        {
          label: "对照录入",
          val: 4
        },
        {
          label: "问卷反馈",
          val: 5
        },
        {
          label: "运营管理",
          val: 10
        },
        {
          label: "逻辑生效",
          val: 3
        },
        {
          label: "患者任务",
          val: 6
        },
        {
          label: "个案提醒",
          val: 7
        },
        // {
        //   label: "患者情况说明",
        //   val: 8
        // },
        {
          label: "病程记录",
          val: 9
        }
      ],
      rightTitleBadge: [],
      userDataList: [], //用户列表
      logOff: false,
      rightData: {}, //右侧模块数据
      IMInfo: Object.create(null), // IM 模块数据
      newPatiend: "",
      setintervalTime: null,
      serviceIMID: {},
      serviceList: [],
      detailFlag: false, // 是否展示左侧患者列表或右侧数据组件
      patientId: "",
      num: 1,
      messagePatientId: null, //点击全局消息列表中的患者id
      messageGroupCode: null, //点击全局消息列表中的患者对应的房间号
      messageWholeCourseId: null, //全局消息进入对应的wholeCourseId
      patientTagVisible: false,
      patientLabelObj: {},
      selectPatientId: '',
    };
  },
  components: {
    IM,
    Tabs,
    NavTab,
    ChatUserList,
    RightContent: () => import("../../components/RightContent/RightContent"),
    PatientTags: () => import("../../components/PatientTags.vue")
  },
  directives: {
    selectLoadmore: {
      bind(el, binding) {
        const SELECTWRAP_DOM = el.querySelector(
          ".el-select-dropdown .el-select-dropdown__wrap"
        );
        SELECTWRAP_DOM.addEventListener("scroll", function() {
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    }
  },
  watch: {
    "$store.state.patientSubmitSymptom": {
      async handler(newVal, oldVal) {
        this.patientSymptomData = this.$store.state.patientSubmitSymptom;
      },
      deep: true,
      immediate: true
    },
    "$store.state.patientObj"(obj) {
      this.formDataValue.keyword = "";
      this.formDataValue.status = "";
      this.messageGroupCode = obj.groupCode;
      this.messagePatientId = obj.patientId;
      this.messageWholeCourseId = obj.wholeCourseId;
      if (!obj.customerService) {
        //疗管消息
        if (this.$route.path == "/case") {
          //非客服房间先切换房间  //当前页面在 疗管页面 刷新数据
          this.handleService(
            { wholeCourseId: this.messageWholeCourseId },
            false,
            this.messagePatientId,
            this.messageGroupCode
          );
        } else {
          //当前页面在客服页面，收到非客服消息，跳转疗管页面
          this.toPage(obj, "IntoTheCase");
        }
      } else {
        if (this.$route.path == "/case") {
          //当前页面在疗管页面，收到客服消息，跳转客服页面
          this.toPage(obj, "customerRoom");
        } else {
          //当前页面在客服页面，收到客服消息，刷新数据
          this.patientListChange("reset");
        }
      }
    }
  },
  created() { 
    if(this.$route.params && this.$route.params.tabClickName){ 
      this.tabClickName = this.$route.params.groupCode
      this.synergyId = this.$route.params.synergyId
    }
    if (this.routerName == "consultRoom") {
      this.rightTitleList.length = 5;
    }
    let userName = this.$route.params.keyword; 
    if (userName) {
      this.formDataValue.keyword = userName;
    }
    this.$socket.emit("currentMenu", "intoCase", data => {});
    if (this.$route.params && this.$route.params.groupCode) {
      this.messageGroupCode = this.$route.params.groupCode;
      this.messagePatientId = this.$route.params.patientId;
      this.messageWholeCourseId = this.$route.params.wholeCourseId;
      if (this.$route.params.roomLevel === 4) {
        // 判断是小房间，则要获取小房间的接口列表，加已读接口调用
      }
      if (!this.$route.params.customerService &&! this.tabClickName) {
        //非客服房间先记录患者最后所在房间，后进入对应房间
        this.handleService(
          { wholeCourseId: this.messageWholeCourseId },
          false,
          this.messagePatientId,
          this.messageGroupCode
        );
      } else { 
        if(this.tabClickName){
          this.patientListChange();
        }else{
          this.patientListChange("reset");
        }
       
      }
    } 
    let param = {
      status: "",
      leftKeywords: this.formDataValue.keyword,
      customerService: this.routerName == "consultRoom" ? true : false
    };
    
    this.$socket.emit("setLeftParams", JSON.stringify(param), data => {});
  },
  mounted() {
    if (this.messageGroupCode) {
      return;
    }
    let end = this.routerName == "consultRoom" ? true : false;
    let logOff = this.seachForm.logOff ? true : false;
    this.$socket.emit("setCurrentPage",`1,${this.formDataValue.size},${end},${logOff}`,data => {}); 
    this.inquireHandel({ ...this.formDataValue, init: true });
  },
  methods: {
    toPage(obj, name) {
      let params = {
        patientId: obj.patientId,
        groupCode: obj.groupCode,
        wholeCourseId: obj.wholeCourseId,
        customerService: obj.customerService
      };
      this.$router.push({
        name: name,
        params: params
      });
    },
    //获取渠道
    getChannelList(key) {
      let params = this.channelSearch;
      if (key) {
        this.channelSearch.current = 1;
        this.channelList = [];
        this.codeLoading = true;
      }
      setTimeout(() => {
        followingChannel(params).then(res => {
          this.codeLoading = false;
          this.channelSearch.totalpages = res.data.pages;
          this.channelList = this.channelList.concat(res.data.records);
        });
      }, 200);
    }, 
    //远程搜索渠道
    remoteChannel(query) {
      this.channelSearch.channelName = query;
      this.channelSearch.current = 1;
      this.getChannelList(true);
    },
    //下拉加载渠道
    loadmoreChannel() {
      this.channelSearch.current++;
      if (this.channelSearch.current > this.channelSearch.pages) {
        return;
      }
      this.getChannelList();
    }, 
    closeChannel(val) {
      if (!val) {
        this.channelSearch.channelName = "";
      } else {
        this.getChannelList(true);
      }
    },
     //获取患者标签
    getPatienTagList (key) {
      let params = this.patientTagSearch;
      if (key) {
        this.patientTagSearch.current = 1;
        this.patientTagList = [];
        this.codeLoading = true;
      }
      setTimeout(() => {
        followingTag(params).then(res => {
          this.codeLoading = false;
          this.patientTagSearch.totalpages = res.data.pages;
          this.patientTagList = this.patientTagList.concat(res.data.records);
        });
      }, 200);
    },
    //远程搜索患者标签
    remotePatientTag(query) {
      this.patientTagSearch.labelName = query;
      this.patientTagSearch.current = 1;
      this.getPatienTagList(true);
    },
    //下拉加载患者标签
    loadmorePatientTag(){
      this.patientTagSearch.current++;
      if (this.patientTagSearch.current > this.patientTagSearch.totalpages) {
        return;
      }
      this.getPatienTagList();
    },
    //删除患者标签
    closePatientTag(val) {
      if (!val) {
        this.patientTagSearch.labelName = "";
      } else {
        this.getPatienTagList(true);
      }
    },
      //获取合作机构
    getCooperateOrgList (key) {
      let params = this.cooperateOrgSearch;
      if (key) {
        this.cooperateOrgSearch.current = 1;
        this.cooperateOrgList = [];
        this.codeLoading = true;
      }
      setTimeout(() => {
        followingCooperateOrg(params).then(res => {
          this.codeLoading = false;
          this.cooperateOrgSearch.totalpages = res.data.pages;
          this.cooperateOrgList = this.cooperateOrgList.concat(res.data.records);
        });
      }, 200);
    },
    //远程搜索合作机构
    remoteCooperateOrg(query) {
      this.cooperateOrgSearch.orgName = query;
      this.cooperateOrgSearch.current = 1;
      this.getCooperateOrgList(true);
    },
    //下拉加载合作机构
    loadmoreCooperateOrg(){
      this.cooperateOrgSearch.current++;
      if (this.cooperateOrgSearch.current > this.cooperateOrgSearch.totalpages) {
        return;
      }
      this.getCooperateOrgList();
    },
    //删除合作机构
    closeCooperateOrg(val) {
      if (!val) {
        this.cooperateOrgSearch.orgName = "";
      } else {
        this.getCooperateOrgList(true);
      }
    },
    //获取关联病种
    getDiseaseList(key) {
      let params = this.diseaseSearch;
      if (key) {
        this.diseaseSearch.current = 1;
        this.diseaseList = [];
        this.codeLoading = true;
      }
      setTimeout(() => {
        followingDisease(params).then(res => {
          this.codeLoading = false;
          this.diseaseSearch.totalpages = res.data.pages;
          this.diseaseList = this.diseaseList.concat(res.data.records);
        });
      }, 200);
    },
    remoteDisease(query) {
      this.diseaseSearch.diseaseTypeName = query;
      this.diseaseSearch.current = 1;
      this.getDiseaseList(true);
    },
    loadmoreDisease() {
      this.diseaseSearch.current++;
      if (this.diseaseSearch.current > this.diseaseSearch.totalpages) {
        return;
      }
      this.getDiseaseList();
    },
    closeDisease(val) {
      if (!val) {
        this.diseaseSearch.diseaseTypeName = "";
      } else {
        this.getDiseaseList(true);
      }
    },
    //获取服务团队
    getServiceTeamList(key) {
      let params = this.serviceTeamSearch;
      if (key) {
        this.serviceTeamSearch.current = 1;
        this.serviceTeamList = [];
        this.codeLoading = true;
      }
      setTimeout(() => {
        followingTeam(params).then(res => {
          this.codeLoading = false;
          this.serviceTeamSearch.totalpages = res.data.pages;
          this.serviceTeamList = this.serviceTeamList.concat(res.data.records);
        });
      }, 200);
    },
    remoteServiceTeam(query) {
      this.serviceTeamSearch.name = query;
      this.serviceTeamSearch.current = 1;
      this.getServiceTeamList(true);
    },
    loadmoreServiceTeam() {
      this.serviceTeamSearch.current++;
      if (this.serviceTeamSearch.current > this.serviceTeamSearch.totalpages) {
        return;
      }
      this.getServiceTeamList();
    },
    closeServiceTeam(val) {
      if (!val) {
        this.serviceTeamSearch.name = "";
      } else {
        this.getServiceTeamList(true);
      }
    },
    //获取服务来源
    getServiceSourceList(key) {
      let params = this.serviceSourceSearch;
      if (key) {
        this.serviceSourceList = [];
        this.codeLoading = true;
      }
      setTimeout(() => {
        followingSource(params).then(res => {
          this.codeLoading = false;
          this.serviceSourceList = res.data;
        });
      }, 200);
    },
    remoteServiceSource(query) {
      this.serviceSourceSearch.name = query;
      this.getServiceSourceList(true);
    },
    closeServiceSource(val) {
      if (!val) {
        this.serviceSourceSearch.name = "";
      } else {
        this.getServiceSourceList(true);
      }
    },
    //获取服务
    getServiceList(key) {
      let params = this.serviceSearch;
      if (key) {
        this.serviceSearch.current = 1;
        this.searchServiceList = [];
        this.codeLoading = true;
      }
      setTimeout(() => {
        followingService(params).then(res => {
          this.codeLoading = false;
          this.serviceSearch.totalpages = res.data.pages;
          this.searchServiceList = this.searchServiceList.concat(
            res.data.records
          );
        });
      }, 200);
    },
    remoteService(query) {
      this.serviceSearch.name = query;
      this.serviceSearch.current = 1;
      this.getServiceList(true);
    },
    loadmoreService() {
      this.serviceSearch.current++;
      if (this.serviceSearch.current > this.serviceSearch.totalpages) {
        return;
      }
      this.getServiceList();
    },
    closeService(val) {
      if (!val) {
        this.serviceSearch.name = "";
      } else {
        this.getServiceList(true);
      }
    },
    //获取机构
    getHospital(key) {
      let params = this.hospitalSearch;
      if (key) {
        this.hospitalSearch.current = 1;
        this.hospitalList = [];
        this.codeLoading = true;
      }
      setTimeout(() => {
        getHospital(params).then(res => {
          this.codeLoading = false;
          this.hospitalSearch.totalpages = res.data.pages;
          this.hospitalList = this.hospitalList.concat(res.data.records);
        });
      }, 200);
    },
    //搜索机构
    remoteHospital(query) {
      this.hospitalSearch.name = query;
      this.hospitalSearch.current = 1;
      this.getHospital(true);
    },
    //分页加载机构
    loadmoreHospital() {
      this.hospitalSearch.current++;
      if (this.hospitalSearch.current > this.hospitalSearch.totalpages) {
        return;
      }
      this.getHospital();
    },
    closeHospital(val) {
      if (!val) {
        this.hospitalSearch.name = "";
      } else {
        this.getHospital(true);
      }
    },

    /**
     * @description: header tabs
     * @param {*}
     * @return {*}
     */
    headerTabsHandel(event) {
      this.seachForm = this.$options.data().seachForm;
      let status = event.id;
      let param = {
        status,
        leftKeywords: "",
        ...this.seachForm,
        customerService: this.routerName == "consultRoom" ? true : false
      };
      this.$socket.emit("setLeftParams", JSON.stringify(param), data => {});
      this.formDataValue.status = event.id;
      // 切换状态重置筛选条件
      this.formDataValue.keyword = "";
      this.formDataValue.current = 1;
      let subSearch = {
        ...this.formDataValue,
        ...this.seachForm
      };
      this.inquireHandel(subSearch, "tabStatus");
    },
    clearInput(){ 
      this.tabClickName = '' 
    },
    // 患者列表筛选条件
    patientListChange(value) { 
      if (value == "reset") {  
        this.seachForm = this.$options.data().seachForm;
      }
      let param = {
        status: this.formDataValue.status,
        leftKeywords: this.formDataValue.keyword,
        ...this.seachForm,
        customerService: this.routerName == "consultRoom" ? true : false
      };
      this.formDataValue.current = 1;
      this.$socket.emit("setLeftParams", JSON.stringify(param), data => {});
      this.formDataValue = {
        ...this.formDataValue,
        ...this.seachForm,
        init: true
      };
      this.inquireHandel(this.formDataValue, "tabSearch");
      this.showPopver = false;
    },
    /**
     * @description: 查询通知
     * @param {*}
     * @return {*}
     */
    inquireHandel(event, tab = "") {  
      this.formDataValue = event;
      if (this.routerName == "consultRoom") {
        event.customerService = true;
      } else {
        event.customerService = false;
      }
      apiGetWholeCourse(event).then(res => {
        if (res.code == 0) {
          //TODO 拿到后台返回的icon角标数量进行处理
          this.tabsDataList = this.tabsDataList.map(item => {
            if (res.data.hasOwnProperty(item.titleName)) {
              item.numberNumber = res.data[item.titleName];
              item.number = res.data[item.title];
            }
            return item;
          });
          //TODO 拿到IM的消息 进行拼接房间id
          if (
            res.data.wholeCoursePageV2VO.records &&
            res.data.wholeCoursePageV2VO.records.length
          ) {
            this.patientTotal = res.data.wholeCoursePageV2VO.total;
            this.userDataList = res.data.wholeCoursePageV2VO.records.map(
              item => {
                if (this.selectPatientId) {
                  if (item.patientId === this.selectPatientId) {
                    item.active = true
                  } else {
                    item.active = false
                  }
                }
                item.imId = "GROUP" + item.imId;
                item.caseGroupRoomId = "GROUP" + item.caseGroupRoomId;
                //疗管不展示客服房间
                if (item.unreadServiceVOS && item.unreadServiceVOS.length) {
                  item.unreadServiceVOS = item.unreadServiceVOS.filter(
                    child => {
                      return !child.consult;
                    }
                  );
                }
                return item;
              }
            );
            //首次加载默认用户列表的第一个
            if (event.init) {
              let index = 0;
              if (this.messageGroupCode) {
                //非疗管页面时：从全局消息列表进入时 定位到对应的患者及进入患者对应的房间
                this.userDataList.map((item, i) => {
                  if (item.patientId == this.messagePatientId) {
                    index = i;
                  }
                });
              } 
              this.propsUserItemHandel(this.userDataList[index], tab, true);
            }
          } else {
            this.userDataList = []; 
            this.serviceIMID = {}
          }
        }
      });
    }, 
    async getApiWholeCourseHandler(event) {
      getPatientDetailedInformationVO({
        patientId: event.patientId,
        type: 1
      }).then(res => {
        this.rightTitleBadge = [
          0,
          0,
          res.data.patientFilesItemNumber,
          res.data.feedbackNumber,
          res.data.evaluationTaskNumber,
          0,
          res.data.patientTaskNumber,
          res.data.caseMgrTaskNumber
        ];
      });
    },

    /**
     * @description: chatUserList子组件传递过来的属性 点击好友列表进入问诊房间 进入问诊房间
     * @param {*}
     * @return {*}
     */
    async propsUserItemHandel(event, tab = "", flag) {
      //清空store存在的右侧tab类型参数
      this.$store.commit("SEARCH_PARAMS", {});
      //表示从全局消息进入疗管页面，先更新最后记录的房间
      if (this.messageGroupCode) {
        //messageup 从全局消息进入时更新当前所在房间的未读数量
        event.messageUp = true;
        //清空全局消息进入标识，避免在右侧患者列表点击房间更新最后所在房间的记录
        this.messageGroupCode = null;
      }
      this.newPatiend = event.patientId;
      this.logOff = event.logOff; // 个案提醒需通过是否注销判断展示添加反馈按钮
      // 点击患者列表关闭已打开问卷弹框
      this.loadMessageIng = true;
      if (!flag) {
        this.$refs.IM.closeDetails();
      }
      console.log('event', event)
      this.$store.commit("patientInfo", event);
      this.$store.dispatch("getPatientSavePage");
      this.selectPatientId = event.patientId
      event.unreadCount = 0;
      this.userDataList = this.userDataList.map(item => {
        if (item.patientId === event.patientId) {
          item.active = true;
        } else {
          item.active = false;
        }
        if (item.unreadServiceVOS && item.unreadServiceVOS.length) {
          item.unreadServiceVOS = item.unreadServiceVOS.filter(child => {
            return !child.consult;
          });
        }
        return item;
      });
      //TODO 获取当前用户的基本信息，对照录入，反馈评估信息
      await this.getApiWholeCourseHandler(event);
      let isFirst = false;
      if (flag) {
        isFirst = true;
      }
      this.getPatientWholeCourseId(event, isFirst);
    },
    //获取切换过房间的患者全病程id
    getPatientWholeCourseId(obj, isFirst) {
      let newImId = null;
      getPatientWholeCourseId()
        .then(res => {
          this.loadMessageIng = false;
          if (res.code == 0) {
            this.checkedWholeCourseId = obj.id;
            if (res.data && JSON.stringify(res.data) != "{}") {
              this.wholeCourseIdList = res.data;
              let end = res.data;
              for (let key in end) {
                if (obj.patientId == key) {
                  this.checkedWholeCourseId = end[key].wholeCourseId;
                  newImId = "GROUP" + end[key].imId;
                }
              }
            } else {
              this.wholeCourseIdList = {};
            }
          }
          if (newImId && !obj.upFlag && this.routerName != "consultRoom") {
            obj.imId = newImId;
          }
          if (isFirst) {
            obj.isFirst = true;
          } 
          this.$set(this, "IMInfo", {
            ...obj, 
            noThird: obj.status == 1 ? true : false, //1未购买
            // pageType: obj.status == 3 ? 2 : "" //3:评估中
          }); 
          this.upMessageNum(this.IMInfo.imId.slice(5));
          if (this.routerName != "consultRoom") {
            this.getServeNameByPatientId();
          }
        })
        .catch(err => {
          this.loadMessageIng = false;
        });
    },
    // 切换患者列表分页
    async propsUserPageChange(currentPage) {
      // 获取患者列表接口数据
      this.formDataValue = {
        ...this.formDataValue,
        current: currentPage,
        init: false
      };
      this.inquireHandel(this.formDataValue, "");
    },
    topUpClick() {
      this.inquireHandel({ ...this.formDataValue, init: false });
    },
    getRightData(event) {
      this.getApiWholeCourseHandler(event);
    },
    // 点击右侧数据表头
    rightTitleClick(val, key) {
      this.detailFlag = true;
      this.num = val;
      //获取基本信息
      this.$refs["rightContent"].checkItem(val);
      this.getPatientWholeCourseId(this.IMInfo);
    },
    // 返回列表页
    backToChatlist() {
      this.detailFlag = false;
      this.$refs["rightContent"].contentTab = 1;
    },
    // 获取服务列表
    async getServeNameByPatientId(flag) {
      if (!this.IMInfo.patientId) {
        return;
      }
      let { code, data } = await getServeNameByPatientId({
        patientId: this.IMInfo.patientId
      }).catch(err => {
        this.serviceList = [];
      });
      if (code === 0) {
        let index = null;
        this.serviceList = data.map((item, i) => {
          if (item.consult) {
            index = i;
          }
          let end = item.source ? "-" + item.source : "";
          if (item.period) {
            end = end + "-" + item.period;
          }
          let endLable = `${item.doctorTeamName}-${item.patientSchemeName?item.patientSchemeName:''}(${this.translateStatus(item.status)})${end}`
          if(!item.wholeCourseId){ 
            //疗管
            if(item.teamType == 'courseManage'){
              endLable = item.doctorTeamName
            }else{
              endLable = item.doctorName + "-" + item.doctorTitle + "-" +item.doctorTeamName
            }
          }
          return {
            ...item,
            caseGroupRoomId: "GROUP" + item.caseGroupRoomId,
            imId: "GROUP" + item.imId,
            keyImId:item.imId+'key'+i, //数据渲染key
            label: `${item.doctorTeamName}-${
              item.patientSchemeName
            }(${this.translateStatus(item.status)})`, 
            // labelTime: `${item.doctorTeamName}-${
            //   item.patientSchemeName
            // }(${this.translateStatus(item.status)})${end}`,
            labelTime:endLable,
            value: "GROUP" + item.imId
          };
        });
        if (index != null) {
          this.serviceList.splice(index, 1);
        } 
        // 判断是否用id 来匹配已选择服务 
        if (!flag) {    
          this.serviceList.forEach(item => {  
            if ((item.wholeCourseId && item.wholeCourseId == this.checkedWholeCourseId) || item.imId == this.IMInfo.imId) {
              this.serviceIMID = item;
              this.$store.commit("serviceItem", item); 
            }
          });
        }
      }
    },
    // 下拉框显示隐藏
    async visibleChange(flag) {
      if (flag) {
        this.getServeNameByPatientId(true);
      }
    },
    translateStatus(status) {
      switch (status) {
        case 1:
          return "未申请";
          break;
        case 2:
          return "未入案";
          break;
        case 3:
          return "评估中";
          break;
        case 4:
          return "待医生确认";
          break;
        case 5:
          return "进行中";
          break;
        case 7:
          return "未开始";
          break;
        case 12:
          return "服务结束";
          break;
      }
    },
    // 切换服务
    changeService(value) {
      this.$store.commit("serviceItem", value);
      // 记录选中服务
      this.loadMessageIng = true;
      this.handleService(value, true,this.IMInfo.patientId,value.imId.slice(5));
    },
    //flag 为false 时表示从全局消息列表进入房间时记录更新最后一次进入的房间
    handleService(value, flag, patientId,imId) { 
      let params = {
        patientId: flag ? this.IMInfo.patientId : patientId,
        wholeCourseId: value.wholeCourseId?value.wholeCourseId:'',
        groupCode:imId
      }; 
      updatePatientGroup(params)
        .then(res => {
          if (!flag) {
            //全局消息进入清空所有筛选条件
            this.patientListChange("reset");
            return;
          }
          if (res.code == 0) {
            this.loadMessageIng = false;
            //默认为第一个患者时， 切换服务 不需要在socket中触发标记未读接口，切换时手动触发标记未读接口
            value.isFirst = false;
            this.$set(this, "IMInfo", {
              ...this.IMInfo,
              ...value,
              isService: true,
              noThird: value.status == 1 ? true : false,
              // pageType: value.status == 3 ? 2 : ""
            });
            this.$refs.chatList.clearChecked();
            this.upMessageNum(value.imId.slice(5));
          }
        })
        .catch(err => {
          this.loadMessageIng = false;
        });
    },
    //更新当前进入房间的未读消息数量
    async upMessageNum(id) {
      deleteRecordByGroupCode({ groupCode: id }).then(res => {});
    },
    // 点击查看患者标签
    patientTagClcik() {
      this.patientTagVisible = true
      this.getPatientLabels()
    },
    async getPatientLabels() {
      let { code, data } = await getListPatientLabelByStatus({
        patientId: this.IMInfo.patientId,//this.IMInfo.patientId
      })
      if (code === 0) {
        console.log('data', data)
        this.patientLabelObj = {
          ...data,
          patientId: this.IMInfo.patientId,
          wholeCourseId: this.messageWholeCourseId,
        }
      }
    },
    // 子组件传参
    upPatientTag() {
      this.getPatientLabels()
    },
    updatePatientTagVisible() {
      this.patientTagVisible = false
    },
    PublicNewMsg: PublicNewMsg
  },
  sockets: {
    leftMenuNumber(datas) {
      if (typeof datas === "string") {
        this.$websocket.dispatch("getLeftMenuNumber", JSON.parse(datas));
        datas = JSON.parse(datas);
      } else {
        this.$websocket.dispatch("getLeftMenuNumber", datas);
      }
      if (datas.result && datas.result.data) {
        let {
          result: { data }
        } = datas;
        let { wholeCoursePageV2VO } = data;
        this.tabsDataList = this.tabsDataList.map(item => {
          if (data.hasOwnProperty(item.titleName)) {
            item.numberNumber = data[item.titleName];
            item.number = data[item.title];
          }
          return item;
        });
        //TODO 拿到IM的消息 进行拼接房间id .records
        if (wholeCoursePageV2VO.records) {
          if (wholeCoursePageV2VO.records.length) {
            this.userDataList = wholeCoursePageV2VO.records.map(item => {
              item.imId = "GROUP" + item.imId;
              item.caseGroupRoomId = "GROUP" + item.caseGroupRoomId;
              item.active = false;
              if (item.patientId === this.IMInfo.patientId) {
                item.active = true;
                if (this.IMInfo.isFirst) {
                  //首次加载设置了默认展示数据 通知后台已读，用于标记未读
                  item.unreadServiceVOS &&
                    item.unreadServiceVOS.map(child => {
                      if ("GROUP" + child.imId == item.imId) {
                        this.upMessageNum(child.imId);
                      }
                    });
                }
              }
              if (item.unreadServiceVOS && item.unreadServiceVOS.length) {
                item.unreadServiceVOS = item.unreadServiceVOS.filter(child => {
                  return !child.consult;
                });
              }
              return item;
            });
          } else {
            this.userDataList = [];
          }
        }
      }
    },
    // 右侧数据
    rightData(data) {
      if (typeof data === "string") {
        data = JSON.parse(data);
      }
      this.rightData = data.result.data;
      this.rightTitleBadge = [
        0,
        0,
        data.result.data.patientFilesItemNumber,
        data.result.data.feedbackNumber,
        data.result.data.evaluationTaskNumber,
        0,
        data.result.data.patientTaskNumber,
        data.result.data.caseMgrTaskNumber
      ];
      this.$set(
        this.IMInfo,
        "patientAnomalyList",
        data.result.data.patientAnomalyList
      );
    }
  }
};
</script> 

<style lang="less">
.patient-tags {
  .el-drawer__header {
    span {
      font-size: 22px;
      font-weight: 500;
      line-height: 22px;
      color: rgba(0, 0, 0, 0.85);
      text-align: center;
    }
    margin-bottom: 8px;
  }
}
</style>
<style scoped lang="less">
@import "../../styles/index.less";
.rewrite-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .label-right {
    margin-left: 50px;
    background-color: #ff0000;
    border-radius: 10px;
    color: #fff;
    font-size: 12px;
    height: 20px;
    line-height: 19px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
  }
}
.red-tag {
  display: block;
  width: 8px;
  height: 8px;
  background: #f14352;
  border-radius: 7px;
  position: absolute;
  top: 10px;
  right: 5px;
}
</style>